module.exports = __webpack_public_path__ + "img/Plone.86ff7c2.svg";